/* eslint-disable */

export function removeRepeaterSection(repeaterIndex, sectionIndex) {
    const section = document.querySelector(`[data-section-id="${repeaterIndex}_${sectionIndex}"]`);

    const fileFields = section.querySelectorAll('.fileField');
    fileFields.forEach(fileField => {
      const removeBtns = fileField.querySelectorAll('[data-dz-remove]');
      removeBtns.forEach(removeBtn => {
        removeBtn.click();
      });
    });

    section.remove(); // Retrait du html de la section
}

/*
* Initialiser le JS (uniquement pour la section nouvellement ajoutée pour certaines fonctions)
*/
export function refreshScripts(sectionID) {
  initFormBuilder(`[data-section-id="${sectionID}"]`);
}
